<template>
  <div id="app">
      <router-view />
  </div>
</template>

<script>
    import Vue from "vue";
    import store from "@/store";
    import lime from "@/lime.js";
    import util from "@/util.js";


    if (typeof store.state.AppData == 'undefined') {
      Vue.set(store.state, 'AppData', {
          height: '100vh',
          width: '100vw',
          img_host:'https://api..com'
      });
    }

    export default {
        data() {
            return store.state.AppData;
        },
        created() {
            let login_view = util.storage_get('login_view', false);
            if (login_view) {
                store.commit('setLoginView', login_view);
            }
        },
        mounted() {
            this.height = document.documentElement.clientHeight || document.body.clientHeight;
            this.width = document.documentElement.clientWidth || document.body.clientWidth;

            window.onresize = () => {
                this.height = document.documentElement.clientHeight || document.body.clientHeight;
                this.width = document.documentElement.clientWidth || document.body.clientWidth;
            }

            this.getLoginview();
        },
        methods: {
            getLoginview() {
                lime.req("CommManageLoginView", {}).then(res => {
                    store.commit('setLoginView', res.data);
                    util.storage_set('login_view', res.data, 3600 * 24);
                })
            }
        }
    }
</script>

<style>
*{
  padding:0;
  margin:0;
  outline :none; /*去除谷歌浏览器默认边框 */
  font-family: "Microsoft YaHei", 'Times New Roman', Times, serif;
}

.el-upload-list__item.is-ready {
  display: none !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.menu{
    display: inline-block;
    padding:0 16px;
    text-align: center;
}

.page {
    height: 39px; 
    line-height: 39px; 
    text-align: right;
    position: fixed;
    bottom: 0;
    right:10px;
    overflow: hidden;
}

.page2 {
    padding: 10px 10px 0 10px;
    width:auto;
    height: 40px;
    overflow: hidden;
}

.el-drawer__header {
    align-items: center;
    color: #72767b;
    display: flex;
    padding-bottom: 20px !important;
    margin-bottom: 0 !important;
    /* padding: 20px 20px 0; */
    background-color: #f2f1f4;
}

.drawer-body{
    padding:10px;
    overflow: auto;
}
.drawer-footer{
    padding: 0 10px;
    border-top:solid 1px #e6e6e6;
    background-color:#fafafa;
}

.topnav_box::-webkit-scrollbar {
    width: 7px;
    height: 10px;
    background-color: #b5b1b1;
}

.topnav_box::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: black;
}

.topnav_box::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #b5b1b1;
}

/* 级联菜单去掉单选按钮 */
.el-cascader-panel .el-radio {
 width: 100%;
 height: 100%;
 z-index: 10;
 position: absolute;
 top: 0px;
 right: 10px;
}
.el-cascader-node__label {
 width: 157px;
}
.el-cascader-panel .el-radio__input {
 visibility: hidden;
}
.el-cascader-panel .el-cascader-node__postfix {
 top: 10px;
}

.el-table th {
    overflow: hidden;
    -ms-user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    background-color: #f2f1f4 !important;
    height: 46px;
    color:#333;
    border:none;
}

.el-dialog__header {
    padding: 20px 20px 16px !important;
    background-color: #f2f1f4;
}

.el-dialog__body {
    padding: 0 !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.el-dialog__footer {
    padding: 10px !important;
    text-align: right;
    box-sizing: border-box;
    background-color: #f2f1f4;
}


.cont{
    background-color: #fafafa;
    border-radius: 4px;
    padding:5px 10px;
    min-height:400px;
}

.detail{
    background-color: #f2f1f4;
    border-radius: 4px;
    padding:5px 10px;
    min-height:80px;
}

.remark{
    background-color: #f2f1f4;
    border-radius: 4px;
    padding:5px 10px;
}

.menu{
    display: inline-block;
    padding:0 16px;
    text-align: center;
}

/* 表不自动换行 */
.el-table td.el-table__cell div{
    white-space: nowrap;
}

.white {
    white-space: nowrap;
    overflow: hidden;/*超出部分溢出*/
    text-overflow: ellipsis;/*溢出的部分使用省略号*/
}

.line2{
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;/*溢出的部分使用省略号*/
}


/* 动态布局 */
.flex{
    display: flex;
    justify-items: start;
    align-items: center;
    flex-wrap: wrap;
}

.left{
    width: 200px
}

.right{
    flex:1;
}


/* 在线编辑器的样式 */
.w-e-toolbar {
    display: flex;
    padding: 0 6px;
    flex-wrap: wrap;
    position: relative;
    border: none !important;
    background-color: #f2f1f4 !important;
    width:auto !important;
}

.w-e-text-container {
    overflow: hidden;
    border: none !important;
    height: 200px;
    z-index: 10000;
    width: auto !important;
}

[aria-hidden="true"] {
  display: none !important;
}

</style>

